var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 90.8 89.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 10.9,
    y1: 80.3,
    x2: 80.7,
    y2: 21.8,
    gradientTransform: "translate(4.8 -4.4) rotate(6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eddc97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#c89532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#eddc97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f9eec9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#eddc97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c89532"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.7.7l6.8,32.1c0,.4.4.7.8.7l32.6,3.4c.9,0,1.1,1.3.4,1.7l-28.4,16.4c-.3.2-.5.6-.4,1l6.8,32.1c.2.9-.9,1.5-1.5.9l-24.4-22c-.3-.3-.7-.3-1.1-.1l-28.4,16.4c-.8.4-1.7-.4-1.3-1.2l13.3-30c.2-.4,0-.8-.2-1.1L.3,29.2c-.7-.6-.2-1.7.7-1.6l32.6,3.4c.4,0,.8-.2.9-.5L47.9.5c.4-.8,1.6-.7,1.7.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightStar);
export default __webpack_public_path__ + "static/media/right-star.84b2be19d94207b05bd5844f0a2be918.svg";
export { ForwardRef as ReactComponent };